import EntityList from './EntityList';
import EntityDetail from './EntityDetail';
import EntityCreate from './EntityCreate';

const routes = [
  {
    index: true,
    element: <EntityList />,
  },
  {
    path: 'new',
    element: <EntityCreate />,
  },
  {
    path: ':id',
    element: <EntityDetail />,
  },
];

export default routes;
export { EntityList, EntityDetail, EntityCreate };
